import { render, staticRenderFns } from "./FilesListTableHeaderActions.vue?vue&type=template&id=4056bece&scoped=true"
import script from "./FilesListTableHeaderActions.vue?vue&type=script&lang=ts"
export * from "./FilesListTableHeaderActions.vue?vue&type=script&lang=ts"
import style0 from "./FilesListTableHeaderActions.vue?vue&type=style&index=0&id=4056bece&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4056bece",
  null
  
)

export default component.exports